import { mergeWith } from 'ramda';

export const mergeOverrideNull = mergeWith((a, b) => (b === null || b === undefined ? a : b));
